import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import AffordableIcon from '../../../../icons/affordable.svg';
import FastIcon from '../../../../icons/fast.svg';
import Tooltip from '@material-ui/core/Tooltip';
import SvgIcon from '@material-ui/core/SvgIcon';
import NumberFormat from 'react-number-format';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import { Collapse, Chip } from '@material-ui/core';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import ShowAllIcon from '../../../../icons/showAll.svg';
import MedicalExamIcon from '../../../../icons/medicalExam.svg';
import DigitalApplicationIcon from '../../../../icons/digitalApplication.svg';
import ConvertibleIcon from '../../../../icons/convertible.svg';
import LevelTermIcon from '../../../../icons/levelTerm.svg';
import DecreasingTermIcon from '../../../../icons/decreasingTerm.svg';

const useStyles = makeStyles(theme => ({
    lightBG: {
        backgroundColor: `${theme.palette.primary.main}16`,
        border: "none",
    },
    primaryColor: {
        color: theme.palette.primary.main
    },
    borderOutline: {
        border: `1px solid ${theme.palette.primary.main}`
    },
    buttonClass: {
        border: 'none',
        backgroundColor: 'inherit',
        color: theme.palette.primary.main,
    },
    backButton: {
        color: "white",
        background: theme.palette.primary.main
    },
}));

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

const FilterChip = (props) => {
    const classes = useStyles();
    let onClick = props.onClick;
    const [selected, setSelected] = useState(props.selected || false);
    useEffect(() => {
        setSelected(props.selected);
    }, [props.selected]);
    if (props.checkbox) {
        onClick = () => {
            setSelected(!selected);
            document.activeElement.blur()
        }
        useEffect(() => {
            if (props.onChange) props.onChange(selected);
        }, [selected]);
    }
    if (selected) {
        return (
            <Chip
                className={`${classes.lightBG} mr-2 py-3 mt-1`}
                label={props.label}
                icon={props.icon}
                color='primary'
                variant="outlined"
                onClick={onClick}
                deleteIcon={props.checkbox ?
                    <CheckBoxIcon className={`filter-delete-icon ${classes.primaryColor}`} /> :
                    <CheckCircleIcon className={`filter-delete-icon ${classes.primaryColor}`} />
                }
                onDelete={onClick}
            />
        );
    } else {
        return (
            <Chip
                className={`${classes.primaryColor} white-chip mr-2 py-3 mt-1`}
                label={props.label}
                icon={props.icon}
                color='primary'
                onClick={onClick}
                deleteIcon={props.checkbox ?
                    <CheckBoxOutlineBlankIcon className={`filter-delete-icon ${classes.primaryColor}`} /> :
                    <RadioButtonUncheckedIcon className={`filter-delete-icon ${classes.primaryColor}`} />
                }
                onDelete={onClick}
            />
        );
    }
}

const FilterItem = (props) => {
    const classes = useStyles();
    const [selected, setSelected] = useState(props.selected || false);
    useEffect(() => {
        setSelected(props.selected);
    }, [props.selected]);
    useEffect(() => {
        if (props.onChange) {
            props.onChange(selected);
        }
    }, [selected]);
    return (
        <Row>
            <FilterChip
                label={props.label}
                icon={props.icon}
                selected={selected}
                onClick={() => setSelected(true)}
            />
            <FilterChip
                label='Show All'
                icon={<ShowAllIcon className={classes.primaryColor} />}
                selected={!selected}
                onClick={() => setSelected(false)}
            />
        </Row>
    );
}

export default function QuoterSort(props) {
    const [expanded, setExpanded] = useState(false);
    const [filterState, setFilterState] = useState(props.filterObject || {
        noMedicalExamOnly: false,
        digitalOnly: false,
        phoneOnly: false,
        convertibleOnly: false,
        levelTerm: true,
        decreasingTerm: true,
    });
    const handleToolTip = (e) => {
        e.stopPropagation();
    }
    useEffect(() => {
        if (props.setFilterObject) props.setFilterObject(filterState);
    }, [filterState]);
    const classes = useStyles();
    return (
        <React.Fragment>
            <div className="filter-control-wrapper">
                <div className="sort-container">
                    <h4>Sort By</h4>
                    <Row className='align-items-center pt-2 mx-0'>
                        <Col xs={12} md={7} className={`px-0 term-quote-sort-rounded`}>
                            <Row className="term-quote-sort-track px-3">
                                <Col xs={6} className={`term-sort-option left-radius pr-2 ${classes.borderOutline} ${props.isSortedByPrice ? classes.lightBG : 'disabled-class'}`} onClick={() => props.setSortedByPrice(true)}>
                                    <div className="icon-container mb-0">
                                        <SvgIcon component={AffordableIcon} color={!props.isSortedByPrice ? 'disabled' : 'primary'} />
                                    </div>
                                    <div className="content-container">
                                        <p className={`title ${props.isSortedByPrice ? classes.primaryColor : 'disabled-class'}`}>Lowest Price</p>
                                        <p className="cost mb-1">{props.lowestPrice ? <NumberFormat value={props.lowestPrice} displayType={'text'} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={'$'} /> : "--"}/mo</p>
                                    </div>
                                    <div className="help-container" onClick={handleToolTip}>
                                        <LightTooltip title="Companies and products offering the best pricing based on your inputs." enterTouchDelay={0}>
                                            <InfoOutlinedIcon className='help-tooltip' />
                                        </LightTooltip>
                                    </div>
                                </Col>
                                <Col xs={6} className={`term-sort-option right-radius pl-2 ${classes.borderOutline} ${!props.isSortedByPrice ? classes.lightBG : 'disabled-class'}`} onClick={() => props.setSortedByPrice(false)}>
                                    <div className="icon-container mb-0">
                                        <SvgIcon component={FastIcon} color={props.isSortedByPrice ? 'disabled' : 'primary'} />
                                    </div>
                                    <div className="content-container">
                                        <p className={`title ${!props.isSortedByPrice ? classes.primaryColor : 'disabled-class'}`}>Fastest Approval</p>
                                        <p className="cost mb-1">{props.fastestRate ? <NumberFormat value={props.fastestRate} displayType={'text'} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={'$'} /> : "--"}/mo</p>
                                    </div>
                                    <div className="help-container" onClick={handleToolTip}>
                                        <LightTooltip title="Companies whose digital underwriting will get you coverage quickly and possibly without a medical exam." enterTouchDelay={0}>
                                            <InfoOutlinedIcon className='help-tooltip' />
                                        </LightTooltip>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/QuoterComponents/QuoterSort.js